import { render } from "./DropButton.vue?vue&type=template&id=724585e6"
import script from "./DropButton.vue?vue&type=script&lang=js"
export * from "./DropButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__